
import Vue from 'vue';
import { FormError } from '@/types/global';
import { transformRichText } from '~/transforms/transformComponents';
import { ValidateCheckbox } from '@/plugins/validators';
import { getTranslationString } from '~/utility/i18n';

export default Vue.extend({
  props: {
    id: { type: String, required: true },
    label: {
      type: [String, Object],
      default: '',
      required: true,
    },
    initialErrors: {
      type: Array,
      default: () => [],
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      element: {} as HTMLFormElement,
      errors: [] as Array<string>,
    };
  },
  mounted() {
    this.element = this.$el.querySelector('#' + this.id) as HTMLFormElement;
    window.addEventListener('validateField', (e: Event) => {
      const eventTarget = (e as CustomEvent).detail.element;
      if (eventTarget === this.element) {
        this.validate();
      }
    });
    window.addEventListener('validateForm', (e: Event) => {
      this.validate();
    });

    if (!this.isRequired) {
      this.$el.setAttribute('data-valid', 'true');
    }

    // check for storybook initial errors
    if (this.initialErrors.length) {
      this.errors = (this.initialErrors as Array<string>).map(item => item);
    }
  },
  methods: {
    validate() {
      this.errors = ValidateCheckbox(this.element, this.errorMessages as Array<FormError>);

      if (this.errors.length === 0) {
        this.$el.setAttribute('data-valid', 'true');
      } else {
        this.$el.removeAttribute('data-valid');
      }
    },
  },
  computed: {
    isRequired(): Boolean {
      const messages = this.errorMessages as Array<FormError>;
      const requiredError = messages.filter((error: FormError) => error.type === 'required');
      return requiredError.length !== 0;
    },
    getLabel(): string {
      let label = transformRichText(this.label);
      if (!this.isRequired) {
        label = `${label} (${getTranslationString(this.$globals, 'optional')})`;
      }
      return label.replace('<div><p>', '<span>').replace('</p></div>', '</span>');
    },
  },
});
